import * as React from 'react'

export default ({ color = '#000' }) => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 8L0 0V16L14.5 8Z" fill={color} />
    </svg>
  )
}
